import { Box, Grid } from "@mui/material";
import { ReactComponent as NoDataIcon } from "assets/PersonSearch3.svg";
import Button from "components/common/Button";
import Basictabs from "components/common/Tabs";
import Typography from "components/common/Typography";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import colors from "styles/Colors";
import { tokens } from "styles/Tokens";
import { DISPLAY_TYPE } from "utils/CommonConstants";
import { routes } from "utils/routes";
import { setConfigTabSelected } from "../Dashboard.slice";
import { Config } from "./Config";

interface Props {
  type: any;
}

function Overview(props: Props) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { type } = props;
  const totalPlans: any = useAppSelector((state) => state?.Dashboard.dashboardReport?.TOTAL_PLANS?.[0]?.totalPlans);
  const configTabSelected = useAppSelector((state) => state.Dashboard.configTabSelected);

  const navigateUrl = () => {};
  const { themeBG = "dark", color, title, tabs = [], buttonVariant = "", buttons } = Config[type];
  const buttonText = buttons && buttons[configTabSelected[type]]?.label;
  const targetURL = (buttons && buttons[configTabSelected[type]]?.targetURL) || navigateUrl;
  const getSelectedTab = (val: number) => {
    dispatch(setConfigTabSelected({ type, val }));
  };
  const getScreenLayout = () => {
    if (type === DISPLAY_TYPE.myPlansOverview && totalPlans < 1) {
      return (
        <Grid
          sx={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: "center",
            position: "relative",
            padding: "24px",

            "&::after": {
              content: '""',
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              background: "linear-gradient(0deg, #2994FF 53.13%, rgba(41, 148, 255, 0.00) 100%);",
              height: "70%"
            }
          }}
        >
          <NoDataIcon />
          <Typography variant="h4" showBold color={tokens.Text.General.Inverse} sx={{ zIndex: 1, marginTop: "-40px" }}>
            You have no active plans at the moment
          </Typography>
          <Button
            sx={{ marginTop: "32px", zIndex: 1 }}
            variant={"primaryWhite"}
            label="Explore Plans in Library"
            onClick={() => navigate(routes.Library)}
          ></Button>
        </Grid>
      );
    }

    return (
      <>
        <Grid
          container
          sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", minHeight: "43px" }}
        >
          <Grid item>
            <Typography color={themeBG === "light" ? tokens.Text.General.Secondary : ""} showBold>
              {title}
            </Typography>
          </Grid>
          {buttons && (
            <Grid item>
              <Button
                size="Small"
                variant={themeBG === "light" ? "outlined" : "secondaryWhite"}
                label={buttonText}
                onClick={() => targetURL(navigate)}
              ></Button>
            </Grid>
          )}
        </Grid>
        <Grid container>
          <Basictabs
            gap="16px"
            marginBottom={DISPLAY_TYPE.highlights === type ? "24px" : "32px"}
            labelVariant={"body2"}
            tabDetails={tabs}
            alignItems="left"
            backgroundColor={color}
            whiteVariant={themeBG === "dark"}
            defaultTab={configTabSelected[type]}
            selectedTab={getSelectedTab}
          ></Basictabs>
        </Grid>
      </>
    );
  };

  return (
    <Box
      sx={{
        background: type === DISPLAY_TYPE.myPlansOverview && totalPlans < 1 ? colors.Blue.Blue300 : color,
        color: themeBG === "light" ? tokens.Text.General.Secondary : tokens.Text.General.Inverse,
        borderRadius: "12px",
        height: themeBG === "light" ? "413px" : "480px",
        padding: "40px 24px 24px"
      }}
      width={themeBG === "light" ? "100%" : "auto"}
    >
      {getScreenLayout()}
    </Box>
  );
}

export default Overview;
